// custom manifold event names

// emits
/** when the widget is injected into the dom tree */
export const CAMPAIGN_WIDGET_INJECTED = 'm-campaign_widget_injected';
interface CampaignWidgetInjectedDetail {
  key: string;
}
export type MCampaignWidgetInjected = CustomEvent<CampaignWidgetInjectedDetail>;

/** whenever the cart */
export const CAMPAIGN_CART_UPDATED = 'm-campaign_cart_updated';

// listens to
export const MANIFOLD_LOAD_REQUEST = 'm-refresh-widgets';
